'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var index$1 = require('../../00.helper/FormField/index.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Checkbox = require('../../01.atoms/Checkbox/Checkbox.js');
var RichText = require('../../01.atoms/RichText/RichText.js');
var Modal = require('../Modal/Modal.js');
var Select = require('react-select');
var Select__default = _interopDefault(Select);
var Select$1 = require('../Select/Select.js');
require('./_index.scss.js');

var _excluded = ["style", "className", "title", "options", "disabled", "value", "defaultValue", "iconSize", "bold", "light", "required", "onKeyUp", "errorTitle", "checkbox", "noOptionsMessage", "requiredLabel", "optionalLabel", "info"];
var CLASSNAME = 'varta-select-advanced',
    cnLight = "".concat(CLASSNAME, "--light"),
    cnWrapperSelect = "".concat(CLASSNAME, "__wrapper-select"),
    cnSelect = "".concat(CLASSNAME, "__select"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnTitleBold = "".concat(cnTitle, "--bold"),
    cnTitleError = "".concat(cnTitle, "--error"),
    cnDisabled = "".concat(CLASSNAME, "--disabled"),
    cnError = "".concat(CLASSNAME, "--error"),
    cnFocus = "".concat(CLASSNAME, "--focus"),
    cnMenuBold = "".concat(CLASSNAME, "--menu-bold"),
    cnSelectOptionLabel = "".concat(cnSelect, "__option__label"),
    cnIconInfo = "".concat(CLASSNAME, "__icon-info"); // override all styles

var styles = {
  clearIndicator: function clearIndicator() {
    return {};
  },
  container: function container() {
    return {};
  },
  control: function control() {
    return {};
  },
  dropdownIndicator: function dropdownIndicator() {
    return {};
  },
  group: function group() {
    return {};
  },
  groupHeading: function groupHeading() {
    return {};
  },
  indicatorsContainer: function indicatorsContainer() {
    return {};
  },
  indicatorSeparator: function indicatorSeparator() {
    return {};
  },
  input: function input() {
    return {};
  },
  loadingIndicator: function loadingIndicator() {
    return {};
  },
  loadingMessage: function loadingMessage() {
    return {};
  },
  menu: function menu() {
    return {};
  },
  menuList: function menuList() {
    return {};
  },
  // multiValue: () => ({}),
  // multiValueLabel: () => ({}),
  // multiValueRemove: () => ({}),
  // noOptionsMessage: () => ({}),
  option: function option() {
    return {};
  },
  placeholder: function placeholder() {
    return {};
  },
  singleValue: function singleValue() {
    return {};
  },
  valueContainer: function valueContainer() {
    return {};
  }
};
/**
 * 
 */

var SelectAdvanced = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(SelectAdvanced, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(SelectAdvanced);

  function SelectAdvanced() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, SelectAdvanced);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "selectRef", /*#__PURE__*/React__default.createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      error: _this.props.error,
      boldMenu: !!_this.props.options.find(function (a) {
        return !!a.options;
      }),
      touchIsPrimary: typeof window !== 'undefined' ? window.matchMedia('(pointer: coarse)').matches : undefined
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onChange", function () {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // select clear returns null :(
      item = item || {};
      var onChange = _this.props.onChange;

      _this.validate(item);

      onChange(item);

      _this.setState({
        value: item.value
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onFocus", function () {
      _this.setState({
        focus: true
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onBlur", function () {
      _this.setState({
        focus: false
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "setRef", function (ref) {
      var innerRef = _this.props.innerRef;
      [innerRef, _this.selectRef].forEach(function (r) {
        if (typeof r === 'function') {
          r(ref);
        } else if (r) {
          r.current = ref;
        }
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "getValue", function () {
      var _this$findDeep;

      var _this$props = _this.props,
          value = _this$props.value,
          defaultValue = _this$props.defaultValue,
          options = _this$props.options;
      var currentValue = _this.state.value;
      return currentValue || value || ((_this$findDeep = _this.findDeep(options, defaultValue)) === null || _this$findDeep === void 0 ? void 0 : _this$findDeep.value) || '';
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "validate", function () {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var required = _this.props.required;

      var _ref = item || {},
          value = _ref.value;

      if (required && !value) {
        _this.setState({
          error: true
        });

        return;
      }

      _this.setState({
        error: false
      });
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(SelectAdvanced, [{
    key: "findDeep",
    value: function findDeep(data, value) {
      if (!value) {
        return undefined;
      }

      return data.map(function (item) {
        if (item.options) {
          return item.options;
        }

        return item;
      }) // .flat()
      .reduce(function (acc, val) {
        return acc.concat(val);
      }, []).find(function (item) {
        return item.value === value;
      });
    }
  }, {
    key: "reduceGroups",
    value:
    /**
     * Display single sub-items as selectable group header
     *
     * @param {Array} options
     */
    function reduceGroups(options) {
      var touchIsPrimary = this.state.touchIsPrimary;

      if (touchIsPrimary) {
        return options;
      }

      return options.map(function (option) {
        if (option.options && option.options.length === 1 && option.label === option.options[0].label) {
          var opt = _rollupPluginBabelHelpers.objectSpread2({}, option);

          opt.value = opt.options[0].value;
          opt.options = null;
          return opt;
        }

        return option;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props2 = this.props,
          style = _this$props2.style,
          className = _this$props2.className,
          title = _this$props2.title,
          options = _this$props2.options,
          disabled = _this$props2.disabled,
          value = _this$props2.value,
          defaultValue = _this$props2.defaultValue,
          iconSize = _this$props2.iconSize,
          bold = _this$props2.bold,
          light = _this$props2.light,
          required = _this$props2.required,
          onKeyUp = _this$props2.onKeyUp,
          errorTitle = _this$props2.errorTitle,
          checkbox = _this$props2.checkbox,
          _noOptionsMessage = _this$props2.noOptionsMessage,
          requiredLabel = _this$props2.requiredLabel,
          optionalLabel = _this$props2.optionalLabel,
          info = _this$props2.info,
          props = _rollupPluginBabelHelpers.objectWithoutProperties(_this$props2, _excluded),
          _this$state = this.state,
          boldMenu = _this$state.boldMenu,
          error = _this$state.error,
          focus = _this$state.focus,
          showInfo = _this$state.showInfo,
          touchIsPrimary = _this$state.touchIsPrimary,
          selected = this.findDeep(options, value) || value,
          defaultSelected = this.findDeep(options, defaultValue) || defaultValue;

      if (touchIsPrimary) {
        return /*#__PURE__*/React__default.createElement(Select$1, _rollupPluginBabelHelpers.extends({}, this.props, {
          items: options
        }));
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(CLASSNAME, className, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnDisabled, disabled), _rollupPluginBabelHelpers.defineProperty(_classNames, cnError, error), _rollupPluginBabelHelpers.defineProperty(_classNames, cnFocus, focus), _rollupPluginBabelHelpers.defineProperty(_classNames, cnLight, light), _rollupPluginBabelHelpers.defineProperty(_classNames, cnMenuBold, boldMenu), _classNames)),
        style: style,
        onKeyUp: onKeyUp
      }, /*#__PURE__*/React__default.createElement("label", null, title && /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnTitle, _rollupPluginBabelHelpers.defineProperty({}, cnTitleBold, bold))
      }, title, required ? requiredLabel : optionalLabel, info && /*#__PURE__*/React__default.createElement("div", {
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();

          _this2.setState({
            showInfo: true
          });
        },
        className: cnIconInfo
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "questionmark-alt",
        size: "xxs"
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapperSelect
      }, /*#__PURE__*/React__default.createElement(Select__default, _rollupPluginBabelHelpers.extends({}, props, {
        onChange: this.onChange,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        innerRef: this.setRef,
        ref: this.setRef,
        styles: styles // menuIsOpen // debug
        ,
        className: cnSelect,
        classNamePrefix: cnSelect,
        options: this.reduceGroups(options),
        isDisabled: disabled,
        defaultValue: defaultSelected,
        value: selected,
        menuPlacement: "auto",
        noOptionsMessage: function noOptionsMessage() {
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, _noOptionsMessage);
        },
        components: {
          // eslint-disable-next-line react/display-name
          DropdownIndicator: function DropdownIndicator(props) {
            return /*#__PURE__*/React__default.createElement(Select.components.DropdownIndicator, props, /*#__PURE__*/React__default.createElement(Icon, {
              className: classNames(cnIcon),
              id: (selected || {}).icon || 'caret-down',
              size: iconSize
            }));
          },
          // eslint-disable-next-line react/display-name
          Option: function Option(props) {
            return /*#__PURE__*/React__default.createElement(Select.components.Option, props, checkbox ? /*#__PURE__*/React__default.createElement(Checkbox, {
              checked: props.isSelected,
              label: props.label
            }) : /*#__PURE__*/React__default.createElement("span", {
              className: cnSelectOptionLabel
            }, props.label));
          }
        }
      })), required && !disabled && /*#__PURE__*/React__default.createElement("input", {
        tabIndex: -1,
        autoComplete: "off",
        style: {
          opacity: 0,
          width: '100%',
          height: 0,
          position: 'absolute'
        },
        value: this.getValue(),
        onFocus: function onFocus() {
          var _this2$selectRef$curr;

          return (_this2$selectRef$curr = _this2.selectRef.current) === null || _this2$selectRef$curr === void 0 ? void 0 : _this2$selectRef$curr.focus();
        },
        required: required,
        onInvalid: this.validate,
        onChange: function onChange() {
          return void 0;
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: cnTitleError
      }, errorTitle)), info && /*#__PURE__*/React__default.createElement(Modal, {
        onClose: function onClose() {
          return _this2.setState({
            showInfo: false
          });
        },
        title: info.title,
        image: info.image,
        open: showInfo,
        showCloseButton: true
      }, /*#__PURE__*/React__default.createElement(RichText, {
        content: info.content
      })));
    }
  }]);

  return SelectAdvanced;
}(React__default.Component);
SelectAdvanced.propTypes = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, index$1.propTypes), {}, {
  bold: PropTypes.bool,

  /** Display a checkbox for each option */
  checkbox: PropTypes.bool,

  /** Additional class name */
  className: PropTypes.string,

  /** Default value */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape()]),

  /** True for disable */
  disabled: PropTypes.bool,

  /** Text if error */
  errorTitle: PropTypes.string,

  /** True for error */
  error: PropTypes.bool,
  // why is this breaking the build process?
  // iconSize: Icon.propTypes.size,

  /** Content of info modal */
  info: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.string,
    content: PropTypes.string
  }),

  /** Ref for inner element */
  innerRef: PropTypes.any,

  /** True for loading */
  isLoading: PropTypes.bool,

  /** True for light styling */
  light: PropTypes.bool,

  /** Name in form */
  name: PropTypes.string,

  /** Text if no options available */
  noOptionsMessage: PropTypes.string,

  /** Callback function */
  onChange: PropTypes.func,

  /** Callback function on key up */
  onKeyUp: PropTypes.func,

  /** Options array */
  options: PropTypes.array.isRequired,

  /** */
  otherTitle: PropTypes.string,

  /** True for custom input */
  other: PropTypes.bool,

  /** Placeholder text */
  placeholder: PropTypes.string,

  /** True if required in form */
  required: PropTypes.bool,

  /** Additional styles object */
  style: PropTypes.object,

  /** */
  tabIndex: PropTypes.any,

  /** Title text */
  title: PropTypes.string,

  /** Current value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape()])
});
SelectAdvanced.defaultProps = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, index$1.defaultProps), {}, {
  checkbox: true,
  iconSize: 'xs',
  onChange: function onChange() {
    return null;
  },
  onKeyUp: function onKeyUp() {
    return null;
  },
  options: [],
  otherTitle: 'other',
  placeholder: '---'
});

module.exports = SelectAdvanced;
